<template>
  <div class="subheader" id="BetTypeSelector">
    <div class="bet-type">
      <div
        :class="[
          'type',
          getBet.type == 'single' || getBet.type == 'multiple' ? 'active' : '',
        ]"
        @click="changeTypeCart('multiple')"
      >
        <span v-if="getBet.type == 'single' && getSettings.single">{{
          $t('single')
        }}</span>
        <span v-else>{{ $t('multiple') }}</span>
      </div>
      <div
        :class="['type', getBet.type == 'integral' ? 'active' : '']"
        @click="changeTypeCart('integral')"
        v-if="getSettings.integral"
      >
        <span>{{ $t('integral') }}</span>
      </div>
      <div
        :class="[
          'type',
          getBet.type == 'system' ? 'active' : '',
          getBet.type == 'integral' ||
          getBet.type == 'single' ||
          getBet.odds.length == 1 ||
          getBet.odds.length > 10
            ? 'disabled'
            : '',
        ]"
        @click="changeTypeCart('system')"
        v-if="getSettings.system"
      >
        <span>{{ $t('system') }}</span>
      </div>
    </div>
    <div class="delete-all pointer" @click="clearCart">
      <span>{{ $t('removeBet') }}</span>
      <v-icon dense>mdi-delete</v-icon>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BetTypeSelector',
  data: () => ({}),
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
    }),
  },
  methods: {
    async clearCart() {
      // this.showCopy = false
      // this.dialog = false
      // this.dialogError = false
      // this.warningOddsChanged = false
      // this.showAlertLogin = false
      this.$root.$emit('cart_handling', true)
      await this.resetCart()
    },
    ...mapActions({
      refreshCart: 'cart/refreshCart',
      setBetType: 'cart/setBetType',
      resetCart: 'cart/resetCart',
    }),

    async changeTypeCart(type) {
      //console.log('changeTypeCart to -> ' + type)

      const vue = this

      if (vue.getBet.odds.length > 10 && type == 'system') {
        return
      }

      if (vue.getBet.type === 'integral' && type === 'system') {
        return
      }

      if (vue.getBet.type != 'simple' && vue.getBet.odds.length > 1) {
        await this.setBetType({ type: type })
        await this.refreshCart()
      }
    },
  },
}
</script>
